import { useContext } from "react";
import { VisibilityContext, type VisibilityContextValue } from "./visibility-provider";

export function useVisibility(): VisibilityContextValue {
	const ctx = useContext(VisibilityContext);
	if (!ctx) {
		throw new Error("useVisibility must be used within VisibilityProvider");
	}

	return ctx;
}
